import {
	ApiClientManager,
	SendMessageInputDto,
	VoidDtoGenericValueDtoSingleOutputMessage,
} from '@api/consumerloans-public-api';
import { UseFetchHookOutput, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useToast } from '@bcp-nextgen-dx-component-factory/design-system';
import { drawers } from '@drawers';
import {
	ExternalAbComponentsActionEnum,
	useDrawer,
	useFetch,
	useGetCurrentBreakpoint,
	useHandleExternalAbComponents,
	useHideScroll,
} from '@hooks';
import { useLoadingStore, usePTCMetadata, useServicesStore, useSessionInfo } from '@store';
import { BaseSessionInfoCompany } from '@types';

export const useFetchSendMessage = (): UseFetchHookOutput<
	SendMessageInputDto,
	VoidDtoGenericValueDtoSingleOutputMessage
> => {
	const saveServiceResponse = useServicesStore((state) => state.saveServiceResponse);
	const metadata = usePTCMetadata();
	const setIsLoadingSendMessage = useLoadingStore((state) => state.setIsLoadingSendMessage);
	const { hide } = useDrawer('sendEmail');
	const { setToast } = useToast();
	const translate = useTranslation();
	const { enable } = useHideScroll();
	const { currentView } = useGetCurrentBreakpoint();
	const applicationContextId = useServicesStore((state) => state.init?.applicationContextId);
	const { handleExternalAbComponents } = useHandleExternalAbComponents();
	const { company } = useSessionInfo();

	return useFetch<SendMessageInputDto, VoidDtoGenericValueDtoSingleOutputMessage>({
		fetchFn: (data: SendMessageInputDto) => {
			setIsLoadingSendMessage(true);
			return ApiClientManager.call.sendMessage({ data: { ...data, metadata, applicationContextId } });
		},
		onSuccess: (res: VoidDtoGenericValueDtoSingleOutputMessage) => {
			if (res.data) {
				setIsLoadingSendMessage(false);
				hide();
				handleExternalAbComponents(ExternalAbComponentsActionEnum.SHOW);
				enable();
				const checkerNull = document.getElementById('mainMenu');
				if (checkerNull !== null) {
					checkerNull.style.zIndex = '1';
				}
				setToast('visible', {
					feedbackStatus: 'success',
					title: translate('simulator.drawers.sendEmail.calculationSent'),
					progressBar: company === BaseSessionInfoCompany.BCP,
					dismissTimer: 3000,
					placement: { vertical: currentView === 'smallView' ? 'top' : 'bottom' },
					actionButtonProps: undefined,
					containerStyles: { zIndex: 9999 },
					onHide: () => {
						const checkerNull = document.getElementById('mainMenu');
						if (checkerNull !== null) {
							checkerNull.style.zIndex = '500';
						}
					},
				});
				saveServiceResponse({ sendMessage: res.data || {} });
			}
		},
		onError: (error) => {
			setIsLoadingSendMessage(false);
			if ((error as any).code !== 'InvalidCaptcha') {
				hide();
			}

			handleExternalAbComponents(ExternalAbComponentsActionEnum.SHOW);
			enable();

			const checkerNull = document.getElementById('mainMenu');
			if (checkerNull !== null) {
				checkerNull.style.zIndex = '1';
			}
			if ((error as any).code !== 'InvalidCaptcha') {
				setToast('visible', {
					feedbackStatus: 'error',
					title: translate('simulator.couldntSendEmail'),
					progressBar: company === BaseSessionInfoCompany.BCP,
					dismissTimer: 3000,
					placement: { vertical: currentView === 'smallView' ? 'top' : 'bottom' },
					actionButtonProps: undefined,
					containerStyles: { zIndex: 9999 },
					// eslint-disable-next-line sonarjs/no-identical-functions
					onHide: () => {
						const checkerNull = document.getElementById('mainMenu');
						if (checkerNull !== null) {
							checkerNull.style.zIndex = '500';
						}
					},
				});
			}
		},
		notShowLoading: true,
	});
};
